import { DiagnosticUser } from "sdk/diagnosticUser";
import { useAppSelector } from "~/store/hooks";

export const useCurrentDiagnosticUser = (): DiagnosticUser | null => {
  return useAppSelector((state) => state.authentication.currentDiagnosticUser);
};
